
import Vue from "vue";
import AppHeader from "@/components/layout/AppHeader.vue";
// import AppFooter from "@/components/layout/AppFooter.vue";

export default Vue.extend({
  name: "AppDefaultLayout",
  components: {
    AppHeader,
  },
});
